module.exports = __webpack_public_path__ + "img/sniperrifle.1953a81d.webp";